import { captureException } from "@sentry/nextjs"
import type { AxiosError } from "axios"

import useTranslation from "../hooks/use_translation"

type Props = {
  error: AxiosError | Error | null
}

const ErrorBoundaryText = ({ error }: Props) => {
  const { t } = useTranslation()
  captureException(error)
  console.error(error)
  const response = error && "response" in error ? error.response : undefined
  console.error(`Request Error: ${error} ${response}`)
  return <span>{t("unexpectedError")}</span>
}

export default ErrorBoundaryText
